import React from "react";
import hamburgerImage from '../img/hamburger-120.png'

export class Hamburger extends React.Component {
  constructor(props) {
    super(props)

    this.renderMenu = this.renderMenu.bind(this)
    this.renderHamburger = this.renderHamburger.bind(this)
  }

  componentDidMount() {
  }

  renderHamburger() {
    return (
      <img id="hamburger-img" src={hamburgerImage} alt="hamburger icon" height="30" width="30" style={{ opacity: 0.89 }}/>
    )
  }

  renderMenu() {
    return (
      <div id="burger-menu">
        <p className="burger-menu-item">
          <a href="https://github.com/SeanFelipe/mobile_prism" className="burger-menu-item">Test Automation</a>
        </p>
        <p className="burger-menu-item">
          <a href="https://seanfelipe.github.io/tech/management/process/react/react-native/testing/2020/04/15/react-hydrazine.html" className="burger-menu-item">React Hydrazine</a>
        </p>
        <p className="burger-menu-item">Apps</p>
        <p>
          <a href="https://seanfelipe.github.io/tech/management/process/fundamentals/testing/2020/04/10/modern-sqa-fundmentals.html" className="burger-menu-item">Management</a>
        </p>
        <p className="burger-menu-item">About</p>
        <p className="burger-menu-item">Contact</p>
      </div>
    )
  }


  render() {
    return (
      <div id="hamburger">
        { this.props.expandMenu
          ? this.renderMenu()
          : this.renderHamburger()
        }
      </div>
    )
  }
}
